export default __webpack_public_path__ + "static/media/Group 3210@2x.f59fc594.png";